import { useContext } from "react";
import { DrawerContext } from "@CONTEXTS";
import { moment } from "@LIBS";
import { Button } from "antd";

import { AiFillEdit } from "react-icons/ai";

const useLogics = ({ adminUser, setAddType }) => {
  const { setDrawer } = useContext(DrawerContext);
  const columns = [
    {
      title: "Adı",
      key: "firstName",
      dataIndex: "firstName",
    },
    {
      title: "Soyadı",
      key: "lastName",
      dataIndex: "lastName",
    },
    {
      title: "E-Posta",
      key: "email",
      dataIndex: "email",
    },
    {
      title: "Oluşturulma Tarihi",
      key: ["meta", "createdOn"],
      dataIndex: ["meta", "createdOn"],
      render: (data) => moment(data).format("DD MMMM YYYY"),
    },
    {
      title: "Rol",
      key: "role",
      dataIndex: "role",
      render: (data) =>
        data === "ADMIN" ? "Tam Yetkili Kullanıcı" : "Kullanıcı",
    },
    {
      title: null,
      key: "edit",
      dataIndex: "edit",
      align: "right",
      render: (data, record, index) => {
        return (
          <Button
            type="primary"
            icon={<AiFillEdit />}
            onClick={() => {
              setAddType("single");
              setDrawer({
                title: `${record.email} - Gönderi Detayı`,
                ...record,
              });
            }}
            disabled={adminUser === record.id}
          >
            Düzenle
          </Button>
        );
      },
    },
  ];

  const excelColumns = [];
  const searchKeys = [];
  return { columns, excelColumns, searchKeys };
};

export default useLogics;
